import { render, staticRenderFns } from "./miscTreatyInfo2.vue?vue&type=template&id=53b1f4ee&"
import script from "./miscTreatyInfo2.vue?vue&type=script&lang=js&"
export * from "./miscTreatyInfo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports